import { ROUTES } from 'constants/routes';
import { useRouteMatch } from 'react-router-dom';

const sections = [
  ROUTES.dashboard.root,
  ROUTES.orders.root,
  ROUTES.seeding.root,
  ROUTES.development.root,
  ROUTES.transport.root,
];

export const useSection = (): string | undefined => {
  const matches = sections
    .map((section) => useRouteMatch(section))
    .filter((section) => section);
  return matches[0]?.path;
};
